var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21006 5.35659C1.14197 5.24877 1.10792 5.19486 1.08886 5.11171C1.07455 5.04925 1.07455 4.95075 1.08886 4.88829C1.10792 4.80514 1.14197 4.75123 1.21006 4.64341C1.77276 3.75242 3.4477 1.5 6.0002 1.5C8.5527 1.5 10.2276 3.75242 10.7903 4.64341C10.8584 4.75123 10.8925 4.80514 10.9115 4.88829C10.9259 4.95075 10.9259 5.04925 10.9115 5.11171C10.8925 5.19486 10.8584 5.24877 10.7903 5.35659C10.2276 6.24758 8.5527 8.5 6.0002 8.5C3.4477 8.5 1.77276 6.24758 1.21006 5.35659Z",
    stroke: "#0045F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0002 6.5C6.82863 6.5 7.5002 5.82843 7.5002 5C7.5002 4.17157 6.82863 3.5 6.0002 3.5C5.17177 3.5 4.5002 4.17157 4.5002 5C4.5002 5.82843 5.17177 6.5 6.0002 6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ea108cdc4ac3a9bdbc805b9f7cc1cec4.svg";
export { ForwardRef as ReactComponent };